export default __webpack_public_path__ + "static/media/4、首页有气草本.c25a0aed.jpg";